import { Link } from "react-router-dom";

type SectionHeadingProps = {
  title: string;
  subtitle?: string;
  to?: string;
  linkLabel?: string;
};

export default function SectionHeading({ title, subtitle, to, linkLabel }: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-6 md:mb-8">
      <div>
        <h2 className="font-heading text-xl md:text-2xl text-foreground-50 flex items-center gap-2">
          <span className="w-1 h-5 rounded-full bg-accent-500"></span>
          {title}
        </h2>
        {subtitle && <p className="text-sm text-foreground-500 mt-2">{subtitle}</p>}
      </div>
      {to && (
        <Link
          to={to}
          className="shrink-0 text-sm text-foreground-400 hover:text-accent-400 transition-colors flex items-center gap-1 whitespace-nowrap"
        >
          {linkLabel || "查看全部"}
          <i className="ri-arrow-right-line"></i>
        </Link>
      )}
    </div>
  );
}